import React from 'react';

export default function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.5.0@rc-util/es/Children/toArray.js
// module id = 87
// module chunks = 1